<template>
	<div >
		<div style="padding: 0 220px 20px;">
			<div class="list_box" v-for="(item, index) in count" :key="index" infinite-scroll-disabled="disabled">
				<div class="two-overflow type_size_22">
					{{item.title_pure}}
				</div>
				<div class="p_flex p_f_a p_f_b p_m_t_20">
					<div class="p_flex type_size_16">
						<span class="subject_color">{{item.grade_def}}</span>
						<el-divider direction="vertical"></el-divider>
						<span class="subject_yellow">{{item.subject_def}}</span>
						<el-divider direction="vertical"></el-divider>
						<span>{{item.question_type_def }}</span>
						<el-divider direction="vertical"></el-divider>
						<span>{{item.score}}分</span>
					</div>
					<div class="p_flex">
						<el-checkbox-group v-model="checkedCities" @change="change">
							<el-checkbox :label='item.id' :checked='ids.indexOf(item.id+"")>=0' >{{""}}</el-checkbox>
						</el-checkbox-group>
					</div>
				</div>
			</div>
		</div>
		<pagination @get="get" :index="num"/>
	</div>
</template>

<script>
import pagination from '../../pagination/pagination.vue'
export default {
	props:{
		age:null,  // 年级
		ages:null  //学科
	},
	data() {
		return {
			count: [],
			loading: false,
			radio: 0,
			num:0,
			name:0,
			names:0,
			checkedCities:[],
			arr:[],
			ids:[]
		};
	},
	watch: {
		age:{
			handler(i,o){
				// console.log(i)
				this.name=i
				this.get()
			}
		},
		ages:{
			handler(i,o){
				// console.log(i)
			this.names=i
			this.get()
			}
		}
	},
	components:{
		pagination
	},
	created(){
		if( this.$route.query.ids ){
			this.ids = this.$route.query.ids
		}
		// if(JSON.parse(localStorage.getItem("arr1"))){
		// 	var arr=JSON.parse(localStorage.getItem("arr1"))
		// 	// console.log(arr)
		// 	this.arr = arr
		// }
		if(JSON.parse(this.$route.query.name) && JSON.parse(this.$route.query.names)){
			this.name=JSON.parse(this.$route.query.name)
			this.names=JSON.parse(this.$route.query.names)
		}
		this.get()
	},
	mounted() {

	},
	methods: {
		get(id){
			this.$request.ajax(this).post("/api_teacher/question_list",{
				belonging:this.$route.params.type==0?2:1,   // 1 学校题库 2 我的题库
				grade:this.name,    //年级
				subject:this.names, //学科
				page:this.num == 0 ? 1 : this.num,
				limit:1
			}).then(res=>{
				// console.log(res)
				this.count=res.data.list
				this.num = res.data.count
			})
		},
		change(e) {
			// console.log(e);
			this.$emit('change',e)
		}
	}
};
</script>

<style lang="scss" scoped>
.list_box {
	padding: 20px 0;
	border-bottom: 1px solid #e6e6e6;
	margin: 0 20px;
}
>>> .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
	border-color: #00af63;
	background: #00af63;
}
>>> .el-checkbox__input.is-checked+.el-checkbox__label {
	color: #00af63;
}
>>> .el-checkbox__inner {
	width: 18px;
	height: 18px;
}
>>> .el-checkbox__label {
	font-size: 18px;
}
>>> .el-checkbox__inner:hover {
	border-color: #999999;
}

>>>.el-checkbox__inner::after {
    height: 9px;
    left: 6px;
    top: 1px;
    width: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/commponents/exerciseList.vue